class CountDownClockUtils {
    static checkClientDST() {
        let dateObj = new Date();
        let jan = new Date(dateObj.getFullYear(), 0, 1);
        let jul = new Date(dateObj.getFullYear(), 6, 1);
        let stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
        return dateObj.getTimezoneOffset() < stdTimezoneOffset;
    }

    // Calculate the remaining time
    static getTimeRemaining(endtimeRaw, countBy) {
        // time format for "endtimeRaw" : YYYY/MM/DD hh:mm:ss

        let endtime = new Date(endtimeRaw);
        endtime = endtime.toString();
        let hourMilis = 3600000;
        let additionalOffSet = (this.checkClientDST()) ? 1 : 0;

        // Eastern Time Offset
        let offset = -5.0 + additionalOffSet;
        let clientDate = new Date();
        let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
        let current = new Date(utc + (hourMilis * offset));

        let t = Date.parse(endtime) - Date.parse(current);
        let seconds = Math.floor((t / 1000) % 60);
        let minutes = Math.floor((t / 1000 / 60) % 60);
        let hours = (countBy.indexOf('hour') > -1) ? Math.floor(t / (1000 * 60 * 60)) : Math.floor((t / (1000 * 60 * 60)) % 24);
        let days = (countBy.indexOf('hour') > -1) ? 0 : Math.floor(t / (1000 * 60 * 60 * 24));

        // Build out the JSON object
        return {
            'total': t,
            'days': (days > 0) ? days : 0,
            'hours': (hours > 0) ? hours : 0,
            'minutes': (minutes > 0) ? minutes : 0,
            'seconds': (seconds > 0) ? seconds : 0
        };

    }
}

export default CountDownClockUtils;